import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { ButtonComponent } from '@shared/components/button';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ConfirmationModalData } from './confirmation-modal.model';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [ButtonComponent, FontAwesomeModule],
  templateUrl: './confirmation-modal.component.html',
})
export class ConfirmationModalComponent {
  data: ConfirmationModalData = inject(DIALOG_DATA);
  dialogRef = inject(DialogRef<boolean>);
  faCircleExclamation = faCircleExclamation;

  title = this.data.title;
  message = this.data.message;
  confirmLabel = this.data.confirmLabel ?? 'Confirm';
  cancelLabel = this.data.cancelLabel ?? 'Cancel';

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close(true);
  }
}
